
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/menu/[categorySlug]",
      function () {
        return require("private-next-pages/menu/[categorySlug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/menu/[categorySlug]"])
      });
    }
  